class CustomHeader extends HTMLElement {
  constructor() {
    super();

    this.DOM = {
      shopifySectionHeader: "[id^='shopify-section-header']",
      fullHeader: ".site-header",
      nav: ".navigation",
      hamburger: ".hamburger-menu",
      megaMenuGoBack: ".mega--menu--go--back",
      parentArrow: ".parent--arrow",
      searchForm: "#search-field",
      searchMobile: "[data-open-search]",
      closeSearch: "[data-close-search]",
      closeSearchMobile: ".close_search.mobile",
      sonderBar: "#shopify-section-sonder-bar",
      resetButton: ".reset__button",
      searchIcon: ".icon--search",
      closeDetails: "[data-close-details]",
    };

    this.mobileDrawerEl = this.querySelector(".header__mobile-navigation-wrap");
    this.headerElement = this.querySelector("header");
    this.announcementBarElement = document.querySelector(".announcement-bar");
    this.firstSectionEl = document.querySelector(".shopify-section:first-of-type");
    this.closeAllDetailsEl = this.querySelectorAll("[data-close-all-details]");
    this.searchOpenEl = this.querySelectorAll("[data-open-search]");
    this.searchInputEl = this.querySelector(".header__search-field");

    this.body = document.querySelector("body");
    this.shopifySectionHeader = document.querySelector(this.DOM.shopifySectionHeader);

    this.searchForm = document.querySelector(this.DOM.searchForm);
    this.searchMobile = document.querySelectorAll(this.DOM.searchMobile);
    this.closeSearch = document.querySelectorAll(this.DOM.closeSearch);
    this.closeSearchMobile = document.querySelectorAll(this.DOM.closeSearchMobile);

    this.lastKnownScrollPosition = 0;
    this.ticking = false;
    this.scrollingDirection = "down";

    this.window_height = 0;
    this.double_header_bars = 0;
    this.resetButton = document.querySelector(this.DOM.resetButton);
    this.searchIcon = document.querySelector(this.DOM.searchIcon);

    this.isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    this.detailsEl = this.querySelectorAll("details");
    this.closeDetailsEl = this.querySelectorAll(this.DOM.closeDetails);
  }

  connectedCallback() {
    this.mobileDrawerEl.addEventListener("toggle", () => {
      if (this.mobileDrawerEl.open) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
        this.closeAllDetails(); // Close all details when mobile drawer is closed
      }
    });

    this.closeAllDetailsEl.forEach((el) => {
      el.addEventListener("click", this.closeAllDetails.bind(this));
    });

    this.closeDetailsEl.forEach((el) => {
      el.addEventListener("click", (e) => {
        this.closeDetails(e);
      });
    });

    document.addEventListener("mouseover", (e) => {
      const detailsEl = e.target.closest(".header__megamenu");
      if (!detailsEl) return;
      detailsEl.setAttribute("open", "open");

      if (Shopify.designMode == undefined) {
        detailsEl.addEventListener("mouseleave", function handleMouseLeave() {
          detailsEl.removeAttribute("open");
          detailsEl.removeEventListener("mouseleave", handleMouseLeave);
        });
      }
    });

    if (Shopify.designMode) {
      document.addEventListener("shopify:block:select", (e) => {
        document.querySelector(`details:has(.block-${e.detail.blockId})`).setAttribute("open", "open");
      });
    }

    document.addEventListener("scroll", this.handleScroll.bind(this));

    window.addEventListener("scroll", (e) => {
      this.stickyHeader(e);
    });

    this.calculateMobileNavHeight();
    this.calculateColumnHeights();
    this.calculateCalloutHeights();
    this.handleDetailToggle();

    window.addEventListener("resize", this.calculateMobileNavHeight.bind(this));
    window.addEventListener("resize", this.calculateColumnHeights.bind(this));
    window.addEventListener("resize", this.calculateCalloutHeights.bind(this));

    // ADDING SEARCH BOX EVENT LISTENER
    this.searchForm.addEventListener("focus", (e) => this.searchFocus(e));
    this.searchForm.addEventListener("focusout", (e) => this.searchFocusOut(e));

    Array.from(this.searchMobile).forEach((el) => {
      el.addEventListener("click", (e) => this.searchFocus(e));
    });
    Array.from(this.closeSearch).forEach((el) => {
      el.addEventListener("click", (e) => this.searchFocusOut(e));
    });

    this.toggleResetButton();
  }

  handleDetailToggle() {
    if (!this.detailsEl || !this.detailsEl.length) return;

    this.detailsEl.forEach((details) => {
      details.addEventListener("toggle", (event) => {
        // Remove .is-active from all <details> in this scope
        this.detailsEl.forEach((el) => {
          el.classList.remove("is-active");
          const isLastOpened = el.querySelectorAll("details[open]").length === 0 && el.hasAttribute("open");
          if (isLastOpened) {
            el.classList.add("is-active");
            return;
          }
        });
      });
    });
  }

  closeDetails(e) {
    const details = e.target.closest("details");
    details.open = false;
    details.dispatchEvent(new Event("toggle"));
  }
  closeAllDetails() {
    this.querySelectorAll("details").forEach((detailsEl) => {
      detailsEl.removeAttribute("open");
    });
  }

  handleScroll() {
    const firstSectionHeight = this.firstSectionEl.getBoundingClientRect().height;
    const firstSectionTop = this.firstSectionEl.getBoundingClientRect().top;

    const firstSectionPosition = (firstSectionTop / firstSectionHeight) * 100 * -1;

    if (firstSectionPosition > 50) {
      this.headerElement.classList.add("scrolled");

      return;
    }

    this.headerElement.classList.remove("scrolled");
  }

  stickyHeader(e) {
    if (this.lastKnownScrollPosition < window.scrollY) {
      this.scrollingDirection = "down";
    } else {
      this.scrollingDirection = "up";
    }
    this.lastKnownScrollPosition = window.scrollY;

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        if (this.lastKnownScrollPosition > this.double_header_bars) {
          this.shopifySectionHeader.classList.add("header--sticky");
          if (this.scrollingDirection === "up") {
            this.shopifySectionHeader.classList.add("header--sticky-mobile");
          } else {
            this.shopifySectionHeader.classList.remove("header--sticky-mobile");
          }
        } else {
          this.shopifySectionHeader.classList.remove("header--sticky");
          this.shopifySectionHeader.classList.remove("header--sticky-mobile");
        }

        this.ticking = false;
      });

      this.ticking = true;
    }
  }

  calculateSearchPositions() {
    let form = this.searchForm.closest("form");
    const formInner = form.querySelector(".header__search-form");
    const rect = form.getBoundingClientRect();

    const searchWidth = formInner.getBoundingClientRect().width;
    const searchLeft = rect.left;
    const searchTop = rect.bottom;

    document.documentElement.style.setProperty("--searching-area-left", `${searchLeft}px`);
    document.documentElement.style.setProperty("--searching-area-top", `${searchTop}px`);
    document.documentElement.style.setProperty("--searching-area-width", `${searchWidth}px`);
  }

  /**
   * Calculates height for mobile navigation.
   */
  calculateMobileNavHeight() {
    const headerHeight = this.headerElement.getBoundingClientRect().height; // Exact height
    const announcementHeight = this.announcementBarElement
      ? this.announcementBarElement.getBoundingClientRect().height
      : 0; // Handle case where there is no announcement bar

    document.documentElement.style.setProperty("--_header-height", `${headerHeight}px`);
    document.documentElement.style.setProperty("--_announcement-bar-height", `${announcementHeight}px`);
  }

  calculateColumnHeights() {
    // TODO: add column heights

    this.querySelectorAll(".header__category").forEach((categoryEl) => {
      const titleEl = categoryEl.querySelector(".header__category-title");
      const listEl = categoryEl.querySelector("ul");

      if (!titleEl || !listEl) return; // Prevent errors if elements are missing

      // Get exact heights to avoid rounding issues
      const categoryTitleHeight = titleEl.getBoundingClientRect().height + 0.75 * 16;
      const categoryListHeight = listEl.getBoundingClientRect().height;

      // Calculate row span (using Math.ceil to prevent layout glitches)
      const categoryHeight = Math.ceil((categoryTitleHeight + categoryListHeight) / 4);

      // Apply CSS variable for grid row span
      categoryEl.style.setProperty("--_row-span", `span ${categoryHeight}`);
    });
  }

  calculateCalloutHeights() {
    this.querySelectorAll(".header__callout-block").forEach((calloutEl) => {
      const contentEl = calloutEl.querySelector(".header__callout-block-content");
      if (!contentEl) return; // Prevent errors if element is missing

      // Get precise height without rounding errors
      const calloutHeight = contentEl.getBoundingClientRect().height;
      const rowSpan = Math.ceil((calloutHeight + 32) / 4);

      // Apply CSS variable
      calloutEl.style.setProperty("--_row-span", `span ${rowSpan}`);
    });
  }

  searchFocus() {
    // SET CURRENT HEIGHT
    document.documentElement.style.setProperty("--window-height", `${window.innerHeight}px`);

    this.body.classList.add("showingScroll");
    this.body.classList.add("showing__search");

    this.focusAndOpenKeyboard(document.querySelector("#search-field"), 500);
    this.searchForm.focus();
    if (this.searchForm.getAttribute("value")) {
      this.resetButton.click();
    }

    let form = this.searchForm.closest("form");
    let form_left = form.offsetLeft;

    let container = this.headerElement;

    // SET THE PARENT TO THE DIMENSIONS
    form.style.left = form_left + "px";

    // MAKE THE INPUT ABSOLUTE AND POSITIONED WHERE IT SHOULD BE

    // ADD A CLASS TO THE AREA TO ANIMATE
    window.setTimeout(function () {
      container.classList.add("show__search");
    }, 40);

    this.keyboardOpened = true;
  }

  searchFocusOut(e) {
    // Delay to allow potential click/tap on a search result to register
    setTimeout(() => {
      const activeEl = document.activeElement;
      this.predictiveSearchResults = document.querySelector("#predictive-search-results");
      const clickedInsideSearchForm = this.searchForm?.contains(activeEl);
      const clickedInsideResults = this.predictiveSearchResults?.contains(activeEl);

      if (clickedInsideSearchForm || clickedInsideResults) {
        console.log("Focus still within search area, aborting close");
        return;
      }

      // Continue closing
      this.body.classList.remove("showingScroll");
      this.headerElement?.classList.remove("show__search");
      this.body.classList.remove("showing__search");

      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.setAttribute("style", "display:none !important");
      }

      if (this.searchForm) {
        this.searchForm.value = "";
      }

      if (this.resetButton) {
        this.resetButton.classList.add("hidden");
      }

      this.keyboardOpened = false;

      if (e) e.preventDefault();
    }, 500); // Delay slightly to allow tap to complete
  }

  toggleResetButton() {
    if (this.searchForm && this.resetButton && this.searchIcon) {
      this.searchForm.addEventListener("input", (event) => {
        console.log("Search input changed");
        const resetIsHidden = this.resetButton.classList.contains("hidden");
        if (event.target.value.length > 0 && resetIsHidden) {
          this.resetButton.classList.remove("hidden");
          this.searchIcon.classList.add("hidden");
          this.searchForm.classList.add("no_search_icon");
        } else if (event.target.value.length === 0 && !resetIsHidden) {
          this.resetButton.classList.add("hidden");
          this.searchIcon.classList.remove("hidden");
          this.searchForm.classList.remove("no_search_icon");
        }
      });

      // Add click event listener to the reset button
      this.resetButton.addEventListener("click", () => {
        console.log("Reset button clicked");
        console.log("Value " + this.searchForm.value);
        this.searchForm.value = "";
        console.log("Value " + this.searchForm.value);
        this.resetButton.classList.add("hidden");
        this.searchIcon.classList.remove("hidden");
        this.searchForm.classList.remove("no_search_icon");
        document.querySelector("#search-field").setAttribute("value", "");
        if (document.getElementById("predictive-search-results") !== null) {
          document.getElementById("predictive-search-results").setAttribute("style", "display:none !important");
        }
      });
    }
  }
  focusAndOpenKeyboard(el, timeout) {
    if (!this.isTouchDevice) {
      return;
    }
    if (!this.keyboardOpened && el) {
      // Align temp input element approximately where the input element is
      // so the cursor doesn't jump around
      var __tempEl__ = document.createElement("input");
      __tempEl__.style.position = "absolute";
      __tempEl__.style.top = el.offsetTop + 7 + "px";
      __tempEl__.style.left = el.offsetLeft + "px";
      __tempEl__.style.height = 0;
      __tempEl__.style.opacity = 0;
      // Put this temp element as a child of the page <body> and focus on it
      document.body.appendChild(__tempEl__);
      __tempEl__.focus();

      // The keyboard is open. Now do a delayed focus on the target element
      setTimeout(() => {
        el.focus();
        el.click();
        // Remove the temp element
        document.body.removeChild(__tempEl__);
      }, timeout);

      // Set the flag to true
      this.keyboardOpened = true;
    }
  }
}

customElements.define("custom-header", CustomHeader);

class DrawerToggle extends HTMLElement {
  constructor() {
    super();

    this.elementToControl = this.dataset.controls;
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      e.preventDefault();

      /** @type {HTMLDetailsElement} */
      const drawerEl = document.getElementById(this.elementToControl);
      drawerEl.querySelector("summary").click();
    });
  }

  toggleDrawer() {
    console.log(this.elementToControl);
  }
}

customElements.define("drawer-toggle", DrawerToggle);
